import {pendingTask, begin, end} from 'react-redux-spinner';
import ACTIONS from '../constants/actions';

export const fetchReviews = (options) => ({
  type: ACTIONS.FETCH_REVIEWS,
  payload: {options}
});
export const fetchReviewsSuccess = (reviews, paginator) => ({
  type: ACTIONS.FETCH_REVIEWS_SUCCESS,
  payload: {reviews, paginator}
});
export const fetchReviewsFailed = () => ({
  type: ACTIONS.FETCH_REVIEWS_FAILED
});

export const  resetReviews = () => ({
  type: ACTIONS.RESET_REVIEWS
});

export const fetchReviewsStats = () => ({
  type: ACTIONS.FETCH_REVIEWS_STATS
});
export const fetchReviewsStatsSuccess = ({stats, average}) => ({
  type: ACTIONS.FETCH_REVIEWS_STATS_SUCCESS,
  payload: {stats, average}
});
export const fetchReviewsStatsFailed = () => ({
  type: ACTIONS.FETCH_REVIEWS_STATS_FAILED
});
export const resetReviewsStats = () => ({
  type: ACTIONS.RESET_REVIEWS_STATS
});

export const fetchPartnersReviews = () => ({
  type: ACTIONS.FETCH_PARTNERS_REVIEWS
});
export const fetchPartnersReviewsSuccess = (reviews) => ({
  type: ACTIONS.FETCH_PARTNERS_REVIEWS_SUCCESS,
  payload: {reviews}
});
export const fetchPartnersReviewsFailed = () => ({
  type: ACTIONS.FETCH_PARTNERS_REVIEWS_FAILED
});
export const resetPartnersReviews = () => ({
  type: ACTIONS.RESET_PARTNERS_REVIEWS
});

export const createReview = (params) => ({
  type: ACTIONS.CREATE_REVIEW,
  payload: {params}
});
export const createReviewSuccess = (review) => ({
  type: ACTIONS.CREATE_REVIEW_SUCCESS,
  payload: {review}
});
export const createReviewFailed = (errors) => ({
  type: ACTIONS.CREATE_REVIEW_FAILED,
  payload: {errors}
});
export const resetNewReview = () => ({
  type: ACTIONS.RESET_NEW_REVIEW
});
